import React from "react";
import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";

const FloatingLink = styled.a`
  position: fixed;
  bottom: 18px;
  right: 18px;
  background: #25d366;
  color: #fff;
  width: 62px;
  height: 62px;
  font-size: 1.95rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
  z-index: 999;

  @media (min-width: 768px) {
    width: 70px;
    height: 70px;
    bottom: 25px;
    right: 25px;
  }
`;

const WhatsAppButton = () => {
  return (
    <FloatingLink href="https://wa.me/34683704011" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
      <FaWhatsapp />
    </FloatingLink>
  );
};

export default WhatsAppButton;
